// @ts-strict-ignore
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ThemeService {
	public themeSubject: BehaviorSubject<string>;
	public currentTheme: string;

	public static lightTheme = "simstationLight-theme";
	public static darkTheme = "simstationDark-theme";

	constructor() {
		this.themeSubject = new BehaviorSubject<string>(ThemeService.lightTheme);
	}

	setTheme(theme: string) {
		this.themeSubject.next(theme);
		this.currentTheme = theme;
	}

	public isDarkTheme(): boolean {
		return this.currentTheme === ThemeService.darkTheme;
	}
}
